// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 17776 ? "477d4af2" : chunkId) + "." + {"17776":"675b8eeee589138c","55539":"5a0518572026565e","71429":"534d13d7f658728b"}[chunkId] + ".js";
};